<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import dashboardService from '../../../services/dasboard.service'
import Stat from "../../../components/widgets/stat";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Stat,
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Dashboard",
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "Default",
          active: true,
        },
      ],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#ffffff",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      stats: null
    };
  },
  mounted() {
    this.fetchAnalytics()
  },
  methods: {
    fetchAnalytics() {
      dashboardService.getAnalytics().then(res => {
        this.stats = res
      }).catch(err => {

      })
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>

    <div class="row">

      <div class="col-md-3">
        <stat :value="stats && stats.active_subscription? stats.active_subscription.toString() :  '0'" title="Active Subscriptions"/>
      </div>
      <div class="col-md-3">
        <stat :value="stats &&  stats.subscription_this_month? stats.subscription_this_month.toString() :  '0'" title="Subscriptions This Month"/>
      </div>
      <div class="col-md-3">
        <stat :value="stats && stats.subscription_last_month? stats.subscription_last_month.toString() :  '0'" title="Subscriptions Last Month"/>
      </div>
      <div class="col-md-3">
        <stat :value="stats &&  stats.daily_active_users ? stats.daily_active_users.toString() :  '0'" title="Daily Active Users"/>
      </div>

      <div class="col-md-3">
        <stat :value="stats && stats.monthly_active_users? stats.monthly_active_users.toString() :  '0'" title="Active Users in 30 days"/>
      </div>
      <div class="col-md-3">
        <stat :value="stats && stats.daily_new_signups ? stats.daily_new_signups.toString() :  '0'" title="Daily New Users"/>
      </div>
      <div class="col-md-3">
        <stat :value="stats && stats.monthly_new_signups? stats.monthly_new_signups.toString() :  '0'" title="Monthly New Users"/>
      </div>
      <div class="col-md-3">
        <stat :value="(stats && stats.daily_time_spent_quantity_mode ? stats.daily_time_spent_quantity_mode.toString() :  '0') |timeFormat"
              title="Daily Session Time (Quantity Mode)"/>
      </div>
      <div class="col-md-3">
        <stat :value="(stats && stats.monthly_time_spent_quantity_mode? stats.monthly_time_spent_quantity_mode.toString() :  '0') | timeFormat"
              title="Monthly Session Time (Quantity Mode)"/>
      </div>

      <div class="col-md-3">
        <stat :value="(stats &&  stats.daily_time_spent_session_mode ? stats.daily_time_spent_session_mode.toString() :  '0') | timeFormat"
              title="Daily Session Time (Session Mode)"/>
      </div>
      <div class="col-md-3">
        <stat :value="(stats && stats.monthly_time_spent_session_mode ? stats.monthly_time_spent_session_mode.toString() :  '0') | timeFormat"
              title="Monthly Session Time (Session Mode)"/>
      </div>
      <div class="col-md-3">
        <stat :value="(stats && stats.daily_time_spent_class_room_mode? stats.daily_time_spent_class_room_mode.toString() :  '0') |timeFormat"
              title="Daily Class Room"/>
      </div>
      <div class="col-md-3">
        <stat :value="(stats && stats.monthly_time_spent_class_room_mode? stats.monthly_time_spent_class_room_mode.toString() :  '0') |timeFormat"
              title="Monthly Class Room"/>
      </div>
      <div class="col-md-3">
        <stat :value="(stats && stats.daily_time_spent_round_mode? stats.daily_time_spent_round_mode.toString() :  '0') | timeFormat"
              title="Daily Session Time (Round Mode)"/>
      </div>
      <div class="col-md-3">
        <stat :value="(stats && stats.daily_time_spent?  stats.daily_time_spent.toString()  :  '0') | timeFormat"
              title="Daily Time Spent"/>
      </div>
      <div class="col-md-3">
        <stat :value="(stats && stats.monthly_time_spent? stats.monthly_time_spent.toString() :  '0') |timeFormat"
              title="Monthly Time Spent"/>
      </div>
      <div class="col-md-3">
        <stat :value="(stats && stats.lifetime_time_spent? stats.lifetime_time_spent.toString() :  '0') |timeFormat"
              title="Lifetime Time Spent"/>
      </div>
    </div>
  </Layout>
</template>
